import { Component, OnInit } from '@angular/core';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { GruposService } from 'src/app/services/grupos.service';
import * as CanvasJS from '../../../assets/canvasjs.min';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  respuestaGet:any;
  ingresos:any;
  egresos:any;
  ventas:any;

  gastosClasificados:any;
  gastosClasificadosN:any;
  gastosPorClasificados = [];
  formulario;

  ingresosG;
  egresosG;
  ventasG;
  
  productosD;
  anillosD;
  paquetesD;
  fiestasD;
  viajesD;

  productosG;
  anillosG;
  paquetesG;
  fiestasG;
  viajesG;

  gastosClasificadosG;

  fecha_inicio;
  fecha_fin;
  data:any;

  mostPaquetes:any;
  mostPlacas:any;
  mostMolduras:any;
  mostColores:any;

  constructor(private _dashboard:GruposService, private iziToast:Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getDataDashboard();
    this.getMostSelectedPaquetesDashboard();
    this.formulario = {
      'fecha_inicio':'',
      'fecha_fin':'',
    }
  }


  getDataDashboard(){
    this._dashboard.getDataDashboard().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.ingresos = this.respuestaGet.ingresos;
          this.egresos = this.respuestaGet.egresos;
          this.ventas = this.respuestaGet.ventas;
          this.gastosClasificados = this.respuestaGet.gastosClasificados;

          this.anillosD = this.respuestaGet.anillos;
          this.paquetesD = this.respuestaGet.paquetes;
          this.productosD = this.respuestaGet.productos;
          this.fiestasD = this.respuestaGet.fiestas;
          this.viajesD = this.respuestaGet.viajes;

          this.graficar(this.ingresos, this.egresos, this.ventas, this.gastosClasificados, this.anillosD, this.paquetesD, this.productosD, this.fiestasD, this.viajesD);
         
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar las categorias',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

  graficar(ingresos, egresos, ventas, gastosClasificados, anillos, paquetes, productos, fiestas, viajes){
    console.log(gastosClasificados)
    this.gastosPorClasificados =  [];

    this.ingresosG = ingresos;
    this.egresosG = egresos;
    this.ventasG = ventas;

    this.paquetesG = paquetes;
    this.anillosG = anillos;
    this.productosG = productos;
    this.fiestasG = fiestas;
    this.viajesG = viajes;


    this.gastosClasificadosG = gastosClasificados;

    let chart = new CanvasJS.Chart("chartContainer", {
      theme: "light2",
      animationEnabled: true,
      exportEnabled: true,
      title:{
        text: "Ventas/Ingresos/Egresos"
      },
      data: [{
        type: "column",
        showInLegend: true,
        toolTipContent: "<b>{name}</b>: ${y}",
        indexLabel: "{name}",
        dataPoints: [
          { label: "Ventas", y: this.ventasG, name: "Ventas" },
          { label: "Ingresos", y: this.ingresosG, name: "Ingresos" },
          { label: "Egresos", y: this.egresosG, name: "Egresos" },
        ]
      }]
    });
      
    chart.render(); 
    
    for(var j=0;j<this.gastosClasificadosG.length; j++){
      console.log(this.gastosClasificadosG[j].y);
      console.log(this.gastosClasificadosG);
      this.gastosPorClasificados.push({
           'y': this.gastosClasificadosG[j].name, 'name': this.gastosClasificadosG[j].y
      });
    }

    let chart2 = new CanvasJS.Chart("chartContainer2", {
      theme: "light2",
      animationEnabled: true,
      exportEnabled: true,
      title:{
        text: "Clasificación de gastos"
      },
      data: [{
        type: "pie",
        showInLegend: true,
        toolTipContent: "<b>{name}</b>: ${y} (#percent%)",
        indexLabel: "{name} - #percent%",
        dataPoints: this.gastosPorClasificados,
      }]
    });
      
    chart2.render();

    let chart3 = new CanvasJS.Chart("chartContainer3", {
      theme: "light2",
      animationEnabled: true,
      exportEnabled: true,
      title:{
        text: "Ventas por tipo"
      },
      data: [{
        type: "column",
        showInLegend: true,
        toolTipContent: "<b>{name}</b>: ${y}",
        indexLabel: "{name}",
        dataPoints: [
          { label: "Paquetes", y: this.paquetesG, name: "Paquetes" },
          { label: "Productos", y: this.productosG, name: "Productos" },
          { label: "Anillos", y: this.anillosG, name: "Anillos" },
          { label: "Fiestas", y: this.fiestasG, name: "Fiestas" },
          { label: "Viajes", y: this.viajesG, name: "Viajes" },
        ]
      }]
    });
      
    chart3.render(); 
  }

  filtrarDashboard(){
    this.gastosClasificados = [];
    if (this.formulario.fecha_inicio != null){
      this.fecha_inicio = this.formulario.fecha_inicio['year']+'-'+this.formulario.fecha_inicio['month']+'-'+this.formulario.fecha_inicio['day']
    }

    if (this.formulario.fecha_fin != null){
      this.fecha_fin = this.formulario.fecha_fin['year']+'-'+this.formulario.fecha_fin['month']+'-'+this.formulario.fecha_fin['day']
    }

    this.data = {
      'fecha_inicio':this.fecha_inicio,
      'fecha_fin':this.fecha_fin,
    }

    this._dashboard.filtrarDashboard(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.ingresos = this.respuestaGet.ingresos;
          this.egresos = this.respuestaGet.egresos;
          this.ventas = this.respuestaGet.ventas;
          this.gastosClasificadosN = this.respuestaGet.gastosClasificados;

          this.anillosD = this.respuestaGet.anillos;
          this.paquetesD = this.respuestaGet.paquetes;
          this.productosD = this.respuestaGet.productos;
          this.fiestasD = this.respuestaGet.fiestas;
          this.viajesD = this.respuestaGet.viajes;

          this.graficar(this.ingresos, this.egresos, this.ventas, this.gastosClasificadosN, this.anillosD, this.paquetesD, this.productosD, this.fiestasD, this.viajesD);
        }
      });
    
    this._dashboard.getMostSelectedPaquetesDashboardFiltrados(this.data).subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.mostPaquetes = this.respuestaGet.content;
          this.mostPlacas = this.respuestaGet.placas;
          this.mostMolduras = this.respuestaGet.molduras;
          this.mostColores = this.respuestaGet.colores;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar las categorias',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      });
     
  }

  getMostSelectedPaquetesDashboard(){
    this._dashboard.getMostSelectedPaquetesDashboard().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.mostPaquetes = this.respuestaGet.content;
          this.mostPlacas = this.respuestaGet.placas;
          this.mostMolduras = this.respuestaGet.molduras;
          this.mostColores = this.respuestaGet.colores;
        }else {
          this.iziToast.show(
            {
                title: 'Hubo un problema al cargar las categorias',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }, error => console.error(error))
  }

}
